"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoppingBagProvider = exports.ShoppingBagContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const shoppingBagReducer_1 = require("../reducers/shoppingBagReducer");
exports.ShoppingBagContext = (0, react_1.createContext)({
    state: shoppingBagReducer_1.shoppingBagInitialState,
    dispatch: () => null,
});
/**
 * Use o {@link CartProvider} para prover o contexto do carrinho de compras em vez de usar este provedor diretamente.
 */
const ShoppingBagProvider = ({ children, initialState, }) => {
    const [stateFromReducer, dispatchFromReducer] = (0, react_1.useReducer)(shoppingBagReducer_1.shoppingBagReducer, initialState || shoppingBagReducer_1.shoppingBagInitialState);
    return ((0, jsx_runtime_1.jsx)(exports.ShoppingBagContext.Provider, Object.assign({ value: { state: stateFromReducer, dispatch: dispatchFromReducer } }, { children: children })));
};
exports.ShoppingBagProvider = ShoppingBagProvider;
